module.exports = __webpack_public_path__ + "img/innovating.95ff073.webp";